import * as Yup from 'yup';
import { isNonEmptyValue, isValidEmailValue, isValidPhoneValue } from './onPageSelfScheduleValidation';

// Contact fields only — clinic selection and questions happen inside the
// self-schedule app after the handoff.
//
// Every "is it valid" rule comes from onPageSelfScheduleValidation.js, the same
// predicates the form's live check uses, so the two cannot drift apart (see
// that file for why a disagreement means a dead button). `required` stays here
// only to supply the "Required" message for an empty field.
export const onPageSelfScheduleSchema = Yup.object().shape({
    first_name: Yup.string().required('Required').test('not-blank', 'Only spaces are not allowed', isNonEmptyValue),
    last_name: Yup.string().required('Required').test('not-blank', 'Only spaces are not allowed', isNonEmptyValue),
    email: Yup.string().required('Required').test('valid-email', 'Invalid email', isValidEmailValue),
    phone: Yup.string().required('Required').test('valid-phone', 'Invalid phone number', isValidPhoneValue),
    intent: Yup.string(),
});

export default onPageSelfScheduleSchema;
